import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Prompt, useHistory } from 'react-router-dom'
import { ExpandableObject } from '../../components/abstractObjects/ExpandableObject';
import Input from '../../components/abstractObjects/Input';
import { fetchVar, selectVarById, varUpdated, setEditVarId, updateVarStatus } from './varSlice'
import { selectAllCountries } from '../countries/countriesSlice'
import * as activeVarList from '../activeVarsList/activeVarsListSlice'
import * as pendingVarList from '../pendingVarsList/pendingVarsListSlice'
import QuestionnaireForm from './questionnaireForm'
import AuthorizedSupervisorForm from './authorizedSupervisorForm'
import AlertDialog from '../../components/abstractObjects/AlertDialog'
import ConfirmDialog from '../../components/abstractObjects/ConfirmDialog'
//import VarPhotosList from '../photos/photosList'
import CustomizedSnackbars from '../../components/abstractObjects/Snackbars'
import { Grid, Button, makeStyles } from '@material-ui/core'
import { Label, BasicLabel } from '../../components/abstractObjects/Label'
import { VAR_STATUS_APPROVED, VAR_STATUS_UNAPPROVED } from '../constants'
import { Date, ToShortDate } from '../../components/abstractObjects/Date'
import ReferBackHistory from './referBackHistoryForm'
import {
    Translation
} from '../../features/translations/getTranslation'

const buttonStyles = makeStyles({
    root: {
        width: '100%',
        height: '100%',
        color: 'white',
        fontSize: '1.6rem',
        fontWeight: 'bold',
        backgroundColor: '#1CABE2',
        borderRadius: 5
    }
})


let VarForm = ({ varId }) => {
    const varx = useSelector((state) => selectVarById(state, varId))

    const buttonStyle = buttonStyles()
    const dispatch = useDispatch()
    const history = useHistory()

    //ALERT
    const [alertMessage, setAlertMessage] = useState({ title: null, message: null })
    const [alertActive, setAlertActive] = useState(false)
    const [snackObj, setSnackObj] = useState({ title: null, message: null, type: 'info' })
    const [snackActive, setSnackActive] = useState(false)

    //EXPANDABLE
    const [expandGeneral, setExpandGeneral] = useState(true)
    const [expandVarPoLines, setExpandVarPoLines] = useState(true)
    const [expandQuestionnaire, setExpandQuestionnaire] = useState(true)
    const [expandInspector, setExpandInspector] = useState(true)
    const [expandSupervisor, setExpandSupervisor] = useState(true)
    const [expandReferBackHistory, setExpandReferBackHistory] = useState(true)

    const [addRequestStatus, setAddRequestStatus] = useState('idle')
    const canSave = addRequestStatus === 'idle' // [Id].every(Boolean) &&

    const validateForm = (buttonClicked, back = null) => {
        if (!updateQuestionnaireForm()) {
            setExpandQuestionnaire(false)
            setSnackObj({ message: 'REQUIRED_FIELDS', type: 'error' })
            setSnackActive(true)
            setTimeout(() => { if (back != true) setExpandQuestionnaire(true) }, 1000)
            return false
        }
        if (!updateAuthorizedSupervisorForm({ action: buttonClicked })) {
            setExpandSupervisor(false)
            setTimeout(() => { if (back != true) setExpandSupervisor(true) }, 1000)
            return false
        }
        return true
    }

    const submitForm = async (buttonClicked) => {
        if (!canSave) {
            return false
        }

        setAlertMessage({
            message: "VAR in progress..",
            title: "Submit VAR"
        })
        setAlertActive(true)

        switch (buttonClicked) {
            case "APPROVE": {
                dispatch(updateVarStatus({ VarTransactionId: varx.Id, StatusId: VAR_STATUS_APPROVED }))
                break
            }
            case "UNAPPROVE": {
                dispatch(updateVarStatus({ VarTransactionId: varx.Id, StatusId: VAR_STATUS_UNAPPROVED }))
                break
            }
            default:
                break;
        }

        var err = false
        try {
            setAddRequestStatus("pending")
            const resultAction = await dispatch(varUpdated(varx.Id))
            if ((resultAction.payload != null && (resultAction.payload.Error != null || resultAction.payload.errors != null)) || resultAction.error) {
                err = true
                setAlertMessage({
                    message: resultAction.error | resultAction.payload != null ? resultAction.payload.Error || "An error occurred while updating VAR" : "An error occurred while updating VAR",
                    title: "Submit VAR Failed"
                })
                setAlertActive(true)
                console.log("Problem from server: ", resultAction)
            }
            dispatch(activeVarList.Reload())
            dispatch(pendingVarList.Reload())
        } catch (error) {
            err = true
            setAlertMessage({
                message: "An error occurred while updating VAR",
                title: "Submit VAR Failed"
            })
            setAlertActive(true)
            console.error("Failed to save the var: ", error)
        } finally {
            setAddRequestStatus('idle')
            if (!err)
                history.push(`/active`)
        }
    }

    const countries = useSelector(selectAllCountries)
    var country = countries.find(x => x.Id === varx.CountryId)

    const [questionnaireForm, updateQuestionnaireForm] = QuestionnaireForm({ varId });
    const [authorizedSupervisorForm, updateAuthorizedSupervisorForm] = AuthorizedSupervisorForm({ varId });
    const [referBackHistory, /*updateReferBackHistory*/] = ReferBackHistory({ varId });
    //const [photosForm, /*updatePhotos*/] = VarPhotosList({ varId });
    //const VarAttachmentsCount = varx.VarAttachments.length

    return (
        <React.Fragment>
            <Prompt message={(e) => {
                var validatedSuccess = validateForm("SUBMIT", true)
                if (validatedSuccess)
                    return true
                else return "There's required data to be inserted before continue, are you sure you want to leave?" //You have unsaved changes
            }} />
            <div>
                <ExpandableObject name="GENERAL_INFORMATION" onChange={() => setExpandGeneral(!expandGeneral)} expanded={expandGeneral}>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={6} md={6} mb="0.5rem">
                            <Label text="COUNTRY" /><Input value={country ? country.CountryName : ''} readonly />
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} mb="0.5rem">
                            <Label text="AIRPORT_OF_DESTINATION" /><Input value={varx.ReceivingPort} readonly />
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} mb="0.5rem">
                            <Label text="PO_NUMBER" /><Input value={varx.Pono} readonly />
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} mb="0.5rem">
                            <Label text="AWB No" /><Input value={varx.Awbno} readonly />
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} mb="0.5rem">
                            <Label text="CONSIGNEE" /><Input value={varx.Consignee.ConsigneeName} readonly />
                        </Grid>
                        {/*<Grid item xs={12} sm={6} md={6} mb="0.5rem">*/}
                        {/*    <Label text="Estimated Time Of Arrival" /><Date value={varx.EstimatedDateOfArrival ? varx.EstimatedDateOfArrival : ToShortDate(new window.Date())} readonly />*/}
                        {/*</Grid>*/}
                        <Grid item xs={12} sm={6} md={6} mb="0.5rem">
                            <Label text="MANUFACTURER" /><Input value={varx.Supplier.SupplierName} readonly />
                        </Grid>
                        {/*<Grid item xs={12} sm={12} md={12} mb="0.5rem">*/}
                        {/*    <Label text="Status" /><Input value={varx.Status.StatusDescription} readonly />*/}
                        {/*</Grid>*/}
                    </Grid>
                    <ExpandableObject class="secondaryExpandable" name="DELIVERY_QUANTITY_DESCRIPTION" onChange={() => setExpandVarPoLines(!expandVarPoLines)} expanded={expandVarPoLines}>
                        {varx.VarPoLines.map((VarPoLine, index) => (
                            <div key={index}>
                                <Label text="DELIVERY" style={{ fontWeight: "bold" }} /> <Label text={VarPoLine.DeliveryNumber} /><br />
                                <Label text="ITEM" style={{ fontWeight: "bold" }} /> <Label text={VarPoLine.Poline} /><br />
                                <Label text="DESCRIPTION" style={{ fontWeight: "bold" }} /> <Label text={VarPoLine.VaccineDescription} /><br />
                                <Label text="DELIVERY_QUANTITY" style={{ fontWeight: "bold" }} /> <Label text={VarPoLine.DeliveryQuantity} /><br />
                                {/*<Label text="DELIVERY_QUANTITY_CORRECTED" style={{ fontWeight: "bold" }} /><Label text={VarPoLine.DeliveryQuantityCorrected} /><br />*/}
                                <hr />
                            </div>
                        ))}
                    </ExpandableObject>
                </ExpandableObject>
                <ExpandableObject name="QUESTIONNAIRE" onChange={() => setExpandQuestionnaire(!expandQuestionnaire)} expanded={expandQuestionnaire}>
                    {questionnaireForm}
                </ExpandableObject>
                <ExpandableObject name="INSPECTOR_SIGNATURE" onChange={() => setExpandInspector(!expandInspector)} expanded={expandInspector}>
                    <Label text="NAME" /><Input value={varx.InspectorName ?? ""} readonly />
                    <Label text="SIGNATURE_DATE" />{varx.ConsigneeSignatureDate ? <Date value={varx.ConsigneeSignatureDate} readonly /> : <Input value={ToShortDate(new window.Date())} readonly />}
                    <Label text="EMAIL" /><Input value={varx.Inspector ? varx.Inspector.Email : ""} readonly />
                </ExpandableObject>
                <ExpandableObject name="AUTHORIZED_SUPERVISOR" onChange={() => setExpandSupervisor(!expandSupervisor)} expanded={expandSupervisor} styleDetail={{ padding: 0 }}>
                    {authorizedSupervisorForm}
                </ExpandableObject>
                <ExpandableObject name="REFER_BACK_HISTORY" onChange={() => setExpandReferBackHistory(!expandReferBackHistory)} expanded={expandReferBackHistory}>
                    {referBackHistory}
                </ExpandableObject>
                <Grid container alignItems="center" style={{ margin: '1rem 0' }}>
                    {varx.ImSupervisor ?
                        (<React.Fragment>
                            <Grid item xs={5}>
                                <ConfirmDialog header="ATTENTION" message="VAR_REFER_BACK" agreeFunction={() => submitForm('UNAPPROVE')}>
                                    <Button name="UNAPPROVE" disabled={!canSave} classes={buttonStyle}><BasicLabel text="UNAPPROVE" /></Button>
                                </ConfirmDialog>
                            </Grid>
                            <Grid item xs={2} />
                            <Grid item xs={5}>
                                <ConfirmDialog header="ATTENTION" message="VAR_APPROVE" agreeFunction={() => submitForm('APPROVE')}>
                                    <Button name="APPROVE" disabled={!canSave} classes={buttonStyle}><BasicLabel text="APPROVE" /></Button>
                                </ConfirmDialog>
                            </Grid>
                        </React.Fragment>
                        ) :
                        <ConfirmDialog header="ATTENTION" message="VAR_SUBMIT" onClick={() => validateForm("SUBMIT")} agreeFunction={() => submitForm('SUBMIT')}>
                            <Label style={{ fontWeight: "bold" }} text="COMPLAINT_1" /> <a style={{ fontWeight: "bold", color: "blue" }} target="_blank" href="https://cica.unicef.org">{Translation.t("COMPLAINT_2")}</a> <Label style={{ fontWeight: "bold" }} text="COMPLAINT_3" /><br /><br />
                            <Button name="SUBMIT" disabled={!canSave} style={{ height: 80 }} classes={buttonStyle}><BasicLabel text="SUBMIT" /></Button>
                        </ConfirmDialog>
                    }
                </Grid>
                <CustomizedSnackbars snackActive={snackActive} setSnackActive={setSnackActive} info={snackObj} setInfo={setSnackObj} />
                <AlertDialog alertActive={alertActive} setAlertActive={setAlertActive} info={alertMessage}></AlertDialog>
                <br />
            </div>
        </React.Fragment>
    )
    //<ExpandableObject name = { "PHOTOS (" + VarAttachmentsCount + ")" } onChange = { handleChange('panel8', null) } expanded = { expanded === 'panel8'} onClick = { null/*viewPhotos*/}>
    //    { photosForm }
    //</ExpandableObject>
}

export const VarEditForm = ({ match }) => {
    const { varId } = match.params
    const varx = useSelector(state => selectVarById(state, varId))

    const dispatch = useDispatch()

    let varStatus = useSelector((state) => state.singleVar.status)
    const error = useSelector((state) => state.singleVar.error)

    //gestire una scadenza della risorsa?
    if (!varx) {
        varStatus = 'idle'
    }

    useEffect(() => {
        if (varStatus === 'idle') {
            dispatch(fetchVar(varId))
        }
    }, [varStatus, dispatch, varId])

    let content, contentTitle

    if (varStatus === 'loading') {
        content = <div className="loader"></div>
        contentTitle = 'Loading VAR...'
    } else if (varStatus === 'succeeded') {
        content = <VarForm key={varId} varId={varId} />
        contentTitle = 'EDIT_VAR'
        dispatch(setEditVarId({ varId: varId }))
    } else if (varStatus === 'error') {
        contentTitle = 'Error loading VAR'
        content = <div>{error}</div>
    }

    return (
        <section>
            <br />
            <h2 className="text-center"><BasicLabel text={contentTitle} />{varStatus === 'succeeded' ? ` ${varx.VarreportCode}` : ''}</h2>
            <br />
            {content}
        </section>
    )
}